<template>
    <section class="db-item db-classification">
        <div class="db-item__title">{{ text }}</div>
        <div class="text-right">
            <svg class="db__icon">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="icon" />
            </svg>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        text: {
            type: String
        },
        icon_name: {
            type: String
        }
    },
    computed: {
        icon(){
            return 'icons/sprite.svg#'+this.icon_name;
        }
    }
};
</script>

